import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=333fa50f"
import script from "./SideCart.vue?vue&type=script&lang=ts"
export * from "./SideCart.vue?vue&type=script&lang=ts"
import style0 from "./SideCart.vue?vue&type=style&index=0&id=333fa50f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports